import React, { useState } from 'react';

function SurveyStepThirtyFive({ formData, onNext }) {
    const [finalFeedback, setFinalFeedback] = useState(formData.finalFeedback || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!finalFeedback.trim()) {
            setError('Please share your thoughts before continuing.');
            return;
        }
        setError('');
        onNext({ finalFeedback });
    };

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 8: Open Feedback</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                Please provide any additional comments, concerns, or suggestions for improving our services and working environment: <span className="text-danger">*</span>
            </label>

            <textarea
                className="form-control"
                rows="6"
                value={finalFeedback}
                onChange={(e) => setFinalFeedback(e.target.value)}
                placeholder="Share your thoughts here..."
            />

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!finalFeedback.trim()}
                >
                    Submit
                </button>
            </div>
        </div>
    );
}

export default SurveyStepThirtyFive;
